import React, { useState } from 'react'
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine'
import { RectangularButton } from '../RectangularButton'
import { SelectorDialog } from '../../components'
import style from './style.module.scss'
import { Equipe } from '../types'
import { CalendarPopup } from './CalendarPopup'

export interface CalendarButtonProps {
    equipes: Equipe[]
    ext_competitionId: number
}

const CalendarButtonBlock: React.FC<CalendarButtonProps> = ({ equipes, ext_competitionId }) => {
    const [dialogOpen, setDialogOpen] = useState(false)

    return (
        <BlockWrapper.Without>
            <RectangularButton flatIcon="calendar" onClick={() => setDialogOpen(true)}>
                Ajouter les matchs à votre calendrier
            </RectangularButton>
            <SelectorDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                className={style.popin}
                keepMounted={false}
            >
                <CalendarPopup equipes={equipes} ext_competitionId={ext_competitionId} />
            </SelectorDialog>
        </BlockWrapper.Without>
    )
}

export default defineBlock({
    Block: CalendarButtonBlock,
})
